import {
  VehicleFuelType,
  VehicleStatus,
} from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { VehicleOfferDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import { useTranslation } from "react-i18next";
import VehicleCdn from "@/core/cdn/vehicle/vehicle-cdn";
import { ElectricIcon, FuelIcon } from "@/shared/icons";

type Props = {
  selectedVehicle: VehicleOfferDto;
};

export default function OfferVehicleViewContent({ selectedVehicle }: Props) {
  const { t } = useTranslation("offer");

  const fuelTypeName = selectedVehicle?.fuel
    ? t(`offer.vehicle.${selectedVehicle.fuel.type.toLowerCase()}`)
    : "";

  const modelImage = selectedVehicle?.model
    ? VehicleCdn.getVehicleImage(selectedVehicle.model)
    : "";

  const brandImage = selectedVehicle?.name?.brand
    ? VehicleCdn.getVehicleBrandImage(selectedVehicle.name.brand)
    : "";

  return (
    <>
      <div
        className="size-full flex flex-col p-5"
        style={{
          background:
            "linear-gradient(105deg, rgba(215, 52, 52, 0.30) 0%, transparent 100%), #181818",
        }}
      >
        <div className="relative z-2 flex justify-between">
          <div className="flex flex-col">
            <p className="text-16 font-bold">{selectedVehicle?.name?.brandName}</p>
            <p className="text-16 font-medium opacity-80">{selectedVehicle?.name?.modelName}</p>
          </div>
          <div
            className="w-10.5"
            style={{
              backgroundImage: `url(${brandImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
            }}
          />
        </div>
        <div className="relative z-1 flex justify-between items-end mt-auto">
          <div className="flex items-center gap-2">
            {selectedVehicle?.fuel?.type &&
              (selectedVehicle?.fuel?.type === VehicleFuelType.Electric ? (
                <ElectricIcon className="w-4.5" />
              ) : (
                <FuelIcon className="w-4.5" />
              ))}
            <p className="text-15 font-bold leading-none">{fuelTypeName}</p>
          </div>
          {selectedVehicle?.status && selectedVehicle?.status !== VehicleStatus.Pending && (
            <p
              className="flex justify-center items-center h-6.5 px-2.5 py-[0.44rem] text-10 font-bold uppercase rounded-md"
              style={{
                background:
                  "linear-gradient(90deg, rgba(215, 52, 52, 0.20) 0%, transparent 100%), rgba(36, 36, 36, 0.70)",
              }}
            >
              {t(`offer.vehicle.vehicleStatus.${selectedVehicle?.status?.toLowerCase()}`)}
            </p>
          )}
        </div>
      </div>
      <div
        className="absolute left-1/2 bottom-[2.94rem] w-[16.625rem] h-[4.375rem] -translate-x-1/2"
        style={{
          backgroundImage: "url('/svg/vehicle/circles.svg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
        }}
      />
      <div
        className="absolute left-1/2 top-1/2 w-[16.25rem] h-[9.19rem] -translate-x-1/2 -translate-y-1/2"
        style={{
          backgroundImage: `url(${modelImage})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
        }}
      />
    </>
  );
}
